import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DrawerBody = styled(Box)`
  min-width: 500px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
